import * as numeral from 'numeral';

export class DecimalFormatValueConverter {
  toView(value: Number) {
    return numeral(value).format('0[.]00');
  }
}